import { render, staticRenderFns } from "./OrdersPivotPage.vue?vue&type=template&id=030cc0db&scoped=true&"
import script from "./OrdersPivotPage.vue?vue&type=script&lang=ts&"
export * from "./OrdersPivotPage.vue?vue&type=script&lang=ts&"
import style0 from "./OrdersPivotPage.vue?vue&type=style&index=0&id=030cc0db&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "030cc0db",
  null
  
)

export default component.exports